module.exports = __webpack_public_path__ + "static/media/study-journey.a9c3b7e7.svg";